import { __assign } from "tslib";
import { safeParseDate } from '../utilities/DateUtilities';
import { processUserRelationship } from '../utilities/processUserRelationship';
export function parseRecentResponse(data) {
    /* eslint-disable @typescript-eslint/naming-convention */
    var files = data.files.map(function (file) {
        var userRelationship = file.user_relationship;
        var activityBadge = file.activity_badge
            ? __assign(__assign({}, file.activity_badge), { timestamp: safeParseDate(file.activity_badge.timestamp) }) : undefined;
        var creationInfo = file.creation_info
            ? __assign(__assign({}, file.creation_info), { timestamp: safeParseDate(file.creation_info.timestamp) }) : undefined;
        var modificationInfo = file.modification_info
            ? __assign(__assign({}, file.modification_info), { timestamp: safeParseDate(file.modification_info.timestamp) }) : undefined;
        return __assign(__assign({}, file), { last_recommended_modified_datetime: file.last_recommended_modified_datetime, last_store_modified_datetime: file.last_store_modified_datetime, user_relationship: processUserRelationship(userRelationship), created_datetime: safeParseDate(file.created_datetime), activity_badge: activityBadge, creation_info: creationInfo, modification_info: modificationInfo });
    });
    return {
        diagnostics_data: data.diagnostics_data,
        files: files,
        is_complete: data.is_complete,
    };
    /* eslint-enable @typescript-eslint/naming-convention */
}
//# sourceMappingURL=parseRecentResponse.js.map